import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxAutocompleteModule,
  DxBulletModule,
  DxButtonModule,
  DxCheckBoxModule,
  DxDataGridModule,
  DxDropDownButtonModule,
  DxFormComponent,
  DxFormModule,
  DxListModule,
  DxNumberBoxModule,
  DxPopupModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxTabPanelModule,
  DxToolbarModule,
  DxTooltipModule,
  DxValidationSummaryModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { DxoFormatModule } from 'devextreme-angular/ui/nested';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

/**
 * DevExtreme + Material modullerini tek yerde toplayan ortak modul.
 *
 * Neden var: `libs/*` icindeki bazi bilesenler bu modul setini
 * `apps/e-belediye/src/app/modules/shared/shared.module.ts` uzerinden relative path ile
 * import ediyordu. Bu, Nx proje grafiginde `ui`/`tms`/`gys`/`sts` -> `e-belediye`
 * bagimliligi olusturuyor; `dabnet-kamu` bu lib'lere bagli oldugu icin
 * (nx.json -> targetDefaults.build.dependsOn: ["^build"]) her `nx build dabnet-kamu`
 * onunde e-belediye'yi de bosuna build ediyordu (~4 dk).
 *
 * e-belediye'nin kendi SharedModule'u yerinde birakildi; oradaki `TLCurrencyPipe`,
 * `PaginationComponent` ve recaptcha modulleri e-belediye'ye ozgu oldugu ve `libs/*`
 * tarafinda hicbir yerde kullanilmadigi icin buraya tasinmadi.
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DxButtonModule,
    DxDropDownButtonModule,
    DxScrollViewModule,
    DxToolbarModule,
    DxTabPanelModule,
    DxDataGridModule,
    DxCheckBoxModule,
    DxSelectBoxModule,
    DxNumberBoxModule,
    DxFormModule,
    DxAutocompleteModule,
    DxTooltipModule,
    FormsModule,
    DxoFormatModule,
    MatIconModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    DxPopupModule,
    DxValidatorModule,
    DxValidationSummaryModule,
  ],
  exports: [
    CommonModule,
    DxButtonModule,
    DxDropDownButtonModule,
    DxScrollViewModule,
    DxToolbarModule,
    DxTabPanelModule,
    DxDataGridModule,
    DxCheckBoxModule,
    DxSelectBoxModule,
    DxNumberBoxModule,
    DxFormModule,
    DxAutocompleteModule,
    DxFormComponent,
    DxTooltipModule,
    DxBulletModule,
    DxListModule,
    MatDialogModule,
    FormsModule,
    DxoFormatModule,
    MatIconModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    DxPopupModule,
    DxValidatorModule,
    DxValidationSummaryModule,
  ],
})
export class DkSharedModule {}
